// @flow
import type { Query } from "common/graphql/types"
import gql from "graphql-tag"
import type { Location, ProductGroup, ProductGroupName } from "../types"
import { locationFragment } from "./fragments"
import type { AppConfig, Theme } from "../types"

export const appConfigQuery: Query<AppConfig> = {
  gql: gql`
    query appConfigQuery {
      app {
        getConfig {
          tenantName
          tenantTitle
          hideStores
          enableShipping
          enableBasket
        }
      }
    }
  `,
  options: () => ({
    fetchPolicy: "network-only",
  }),
  selector: ["app", "getConfig"],
}

export const themeQuery: Query<Theme> = {
  gql: gql`
    query themeQuery {
      theme {
        getTheme {
          header {
            html
            css
          }
          footer {
            html
            css
          }
          colors {
            primaryAccent
            primaryAccentDark
            primaryText
            secondaryText
            background
          }
          borderRadiuses {
            button
            filterButton
            input
          }
          fonts {
            externalFontCssUrl
            bodyFontFamily
            headingFontFamily
          }
        }
      }
    }
  `,
  options: () => ({
    fetchPolicy: "network-only",
  }),
  selector: ["theme", "getTheme"],
}

export const geolocationListQuery: Query<
  Location[],
  { productGroups: ?ProductGroupName[] },
> = {
  gql: gql`
    query locationsListQuery($productGroups: [String]) {
      location {
        listLocations(filter: { productGroups: $productGroups }) {
          ...locationFragment
          country {
            name
          }
          distance
          nearby
        }
      }
    }
    ${locationFragment}
  `,
  options: () => ({
    fetchPolicy: "network-only",
  }),
  selector: ["location", "listLocations"],
}

export const locationByNameQuery: Query<Location, { name: string }> = {
  gql: gql`
    query locationByNameQuery($name: String!) {
      location {
        detailByName(name: $name) {
          ...locationFragment
        }
      }
    }
    ${locationFragment}
  `,
  selector: ["location", "detailByName"],
}


export const productGroupListQuery: Query<ProductGroup[]> = {
  gql: gql`
    query productGroupListQuery {
      productGroup {
        list {
          id
          name
          discountOptOuts {
            id
            discountId
          }
        }
      }
    }
  `,
  selector: ["productGroup", "list"],
}


// WEBPACK FOOTER //
// ./src/data/app/graphql/queries.js